(ns practitest.frontend.findandreplace
  (:require
    [ajax.core :as ajax]
    [practitest.frontend.common.dom :refer [event-value]]
    [practitest.frontend.components.spinners :as spinners]
    [practitest.frontend.events :as events]
    [practitest.frontend.init :as init]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.common.utils :as utils]
    [re-frame.core :as re-frame]))

;; subscriptions

(re-frame/reg-sub
  ::title
  :<- [::subs/options]
  (fn [{:keys [title]} _]
    title))

(re-frame/reg-sub
  ::labels
  :<- [::subs/options]
  (fn [{:keys [labels]} _]
    labels))

(re-frame/reg-sub
  ::back-to-url
  :<- [::subs/options]
  (fn [{:keys [back-to-url]} _]
    back-to-url))

(re-frame/reg-sub
  ::fields
  :<- [::subs/options]
  (fn [{:keys [fields]} _]
    (mapcat
      (fn [field]
        [field])
      fields)))

(re-frame/reg-sub
  ::state
  (fn [db _]
    (:find-and-replace-state db)))

(re-frame/reg-sub
  ::stage
  :<- [::state]
  (fn [{:keys [stage]} _]
    stage))

(re-frame/reg-sub
  ::value
  :<- [::state]
  (fn [state [_ field]]
    (get state field)))

(re-frame/reg-sub
  ::selected-fields
  :<- [::state]
  (fn [{:keys [selected-fields]} _]
    selected-fields))

(re-frame/reg-sub
  ::input-invalid?
  :<- [::state]
  (fn [{:keys [find-val replace-val selected-fields]} _]
    (or (not (<= 2 (count find-val) 254))
        (not (<= 0 (count replace-val) 254))
        (empty? selected-fields))))

(re-frame/reg-sub
  ::message
  :<- [::state]
  (fn [{:keys [message]} _]
    message))

;; events

(re-frame/reg-event-db
  ::initialize-db
  (fn [db [_ options]]
    (let [db (if (empty? db)
               {:progress #{}}
               db)]
      (assoc db
        :options (merge (:options db) options)
        :find-and-replace-state {:find-val        ""
                                 :replace-val     ""
                                 :selected-fields #{}
                                 :stage           :prepare}))))

(defn prepare-find-replace [{:keys [db]} _]
  (let [payload {:find-value       (get-in db [:find-and-replace-state :find-val])
                 :entities-ids     (get-in db [:options :entities-ids])
                 :fields-to-change (into [] (get-in db [:find-and-replace-state :selected-fields]))}]
    {:db         (-> db
                     (update :progress conj ::prepare-find-replace)
                     (assoc-in [:find-and-replace-state :message] nil))
     :http-xhrio {:method          :post
                  ;; This is fine here for now
                  :uri             (get-in db [:options :find-replace-check-url])
                  :params          payload
                  :format          (ajax/json-request-format)
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::find-replace-ready]
                  :on-failure      [::bad-http-result ::prepare-find-replace]}}))

(re-frame/reg-event-fx ::prepare-find-replace prepare-find-replace)

(defn find-replace-ready [db [_ {:keys [e_count msg]}]]
  (-> db
      (update :progress disj ::prepare-find-replace)
      (update :find-and-replace-state assoc
              :stage (if (pos? e_count) :ready :prepare)
              :message msg)))

(re-frame/reg-event-db ::find-replace-ready find-replace-ready)

(defn apply-find-replace [{:keys [db]} _]
  (let [payload {:find-value       (get-in db [:find-and-replace-state :find-val])
                 :replace-value    (get-in db [:find-and-replace-state :replace-val])
                 :entities-ids     (get-in db [:options :entities-ids])
                 :fields-to-change (into [] (get-in db [:find-and-replace-state :selected-fields]))
                 :back-to-url      (get-in db [:options :back-to-url])}]
    {:db         (update db :progress conj ::apply-find-replace)
     :http-xhrio {:method          :post
                  ;; This is fine here for now
                  :uri             (get-in db [:options :real-replace-url])
                  :params          payload
                  :format          (ajax/json-request-format)
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::find-replace-completed]
                  :on-failure      [::bad-http-result ::apply-find-replace]}}))

(re-frame/reg-event-fx ::apply-find-replace apply-find-replace)

(defn find-replace-completed [_ [_ data]]
  (let [url (:back-to-url data)]
    {::events/redirect url}))

(re-frame/reg-event-fx ::find-replace-completed find-replace-completed)

(re-frame/reg-event-db
  ::set-value
  (fn [db [_ field value]]
    (assoc-in db [:find-and-replace-state field] value)))

(re-frame/reg-event-db
  ::set-selected-fields
  (fn [db [_ fields]]
    (assoc-in db [:find-and-replace-state :selected-fields] fields)))

(re-frame/reg-event-db
  ::select-field
  (fn [db [_ field]]
    (update-in db [:find-and-replace-state :selected-fields] conj field)))

(re-frame/reg-event-db
  ::unselect-field
  (fn [db [_ field]]
    (update-in db [:find-and-replace-state :selected-fields] disj field)))

(re-frame/reg-event-db
  ::cancel
  (fn [db _]
    (update db :find-and-replace-state assoc
            :stage :prepare
            :message nil)))

;; views
(defn header []
  [:h4.text-truncate @(re-frame/subscribe [::title])])

(defn text-input [{:keys [id field label]}]
  [:div.input-group
   [:span.input-group-text.fw-bold label]
   [:input.form-control {:id        id
                         :type      "text"
                         :value     @(re-frame/subscribe [::value field])
                         :disabled  (= :ready @(re-frame/subscribe [::stage]))
                         :on-change #(re-frame/dispatch-sync [::set-value field (event-value %)])}]])

(defn checkbox-input [label checked-fn? on-change]
  [:label.form-check-label
   [:input.form-check-input.me-1 {:type      "checkbox"
                                  :checked   (checked-fn?)
                                  :disabled  (= :ready @(re-frame/subscribe [::stage]))
                                  :on-change #(on-change (event-value %))}]
   label])

(defn fields []
  (let [fields @(re-frame/subscribe [::fields])
        all-fields (set (map first fields))
        labels @(re-frame/subscribe [::labels])]
    [:div.row
     [:div.col-2
      [:span.fw-bold (:apply-to labels)]
      [:p.mt-3.small.text-muted (get-in labels [:info :min-input-fields])]]
     [:div.col-10
      [:div.row
       [:div.col
        [:div.form-check.ms-3
         [checkbox-input (:all labels)
          #(= all-fields @(re-frame/subscribe [::selected-fields]))
          #(re-frame/dispatch [::set-selected-fields (if % all-fields #{})])]]]]
      [:div.row [:div.col [:hr]]]
      [:div.row
       [:div.col
        (into [:ul.list-group]
              (for [[field label] fields]
                [:li.list-group-item
                 [checkbox-input label
                  #(contains? @(re-frame/subscribe [::selected-fields]) field)
                  #(re-frame/dispatch [(if % ::select-field ::unselect-field) field])]]))]]]]))

(defn render-info [info]
  [:div.alert {:style {:background-color "var(--pt-color-background)"}}
   [:span.small.bold.text-white.px-2.py-1.bg-info (:info-title info)]
   [:p.mt-3.mb-1.bold (:find-and-replace-bold info)]
   [:p.mb-1.ps-2 (:case-sensitive info)]
   [:p.mb-1.ps-2 (:field-types info)]
   [:p.mb-1.bold (:find-and-replace-cannot-bold info)]
   [:p.mb-1.ps-2 (:integrated-fields info)]
   [:p.mb-1.ps-2 (:step-parameters info)]
   [:p.mb-1.bold (:in-instances info)]])

(defn find-and-replace-ui []
  (let [labels         @(re-frame/subscribe [::labels])
        input-invalid? @(re-frame/subscribe [::input-invalid?])
        in-progress?   @(re-frame/subscribe [::subs/progress? ::prepare-find-replace])
        message        @(re-frame/subscribe [::message])]
    [:div.card {:style {:width  "90%"
                        :border "none"}}
     [:div.card-header [header]]
     [:div.row
      [:div.col-6.mb-2
       [:div.card-body
        (when (= :ready @(re-frame/subscribe [::stage]))
          {:style {:opacity 0.7}})
        [:div.row.mb-5
         [:div.col
          [:div.mb-2 [text-input {:id    "find-and-replace-field-find"
                                  :field :find-val
                                  :label (:find labels)}]]
          [:div.small.text-muted (get-in labels [:info :min-input-characters])]]
         [:div.col [text-input {:id    "find-and-replace-field-replace"
                                :field :replace-val
                                :label (:replace labels)}]]]
        [fields]]
       [:div.card-body.text-center
        [:a.card-link.float-start {:href @(re-frame/subscribe [::back-to-url])}
         (:go-back labels)]
        [:button.card-link.btn.btn-sm.btn-dark.float-end
         {:id       "find-and-replace-button"
          :disabled (or input-invalid? in-progress? (= :ready @(re-frame/subscribe [::stage])))
          :on-click #(re-frame/dispatch [::prepare-find-replace])}
         (when in-progress?
           [spinners/inline-spinner-border])
         (:find-n-replace labels)]]]
      [:div.col-2]
      [:div.col-4
       [:div.card-body
        [render-info (:info labels)]]]]
     (when (some? message)
       [:div.card-footer.text-center.alert-warning
        {:style {:margin-bottom "30px"
                 :margin-left   "16px"}}
        [:div.float-start.pt-1
         message]
        (when (= :ready @(re-frame/subscribe [::stage]))
          [:div.float-end
           [:a.card-link.text-decoration-none.text-black
            {:id       "find-and-replace-button-cancel"
             :href     "#"
             :on-click #(re-frame/dispatch [::cancel])}
            "Cancel"]
           [:button.card-link.btn.btn-sm.btn-dark
            {:id       "find-and-replace-button-confirm"
             :style    {:margin-left "30px"}
             :on-click #(re-frame/dispatch [::apply-find-replace])}
            "Confirm"]])])]))

(defn ^:dev/after-load mount-root []
  (init/remount-roots "find-and-replace-component"
                      find-and-replace-ui))

;; TODO: second integration without shadow DOM
(defn ^:export init [webcomponent options]
  (init/init! {:options       options
               :init-event-fn (fn [config]
                                [::initialize-db config])
               :webcomponent  webcomponent
               :root-view     find-and-replace-ui}))

(utils/register-webcomponent! "find-and-replace-component")
